import { Container, Row, Col } from "react-bootstrap";
import chatIcon from "../assets/img/Chat-Icon.svg";
import HotelIcon from "../assets/img/HotelIcon.svg";
import FlightIcon from "../assets/img/FlightIcon.svg";
import MedicalVisaIcon from "../assets/img/MedicalVisaIcon.svg";
import DocumentIcon from "../assets/img/DocumentIcon.svg";
import DoctorIcon from "../assets/img/DoctorIcon.svg";
import CareIcon from "../assets/img/CareIcon.svg";
import HospitalIcon from "../assets/img/HospitalIcon.svg";

export const Services = () => {
  return (
    <section className="services" id="services">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={6}>
            <h1>
              Our <span className="pencilline1">Services</span>
            </h1>
            <p>
              You can <span style={{ color: "#306AFF" }}>count on us</span>, we
              support you every step of the way.
            </p>
            <button className="button-colour">Get in Touch</button>
          </Col>
          <Col xs={12} md={6} xl={3}>
            {/* Free Consultation */}
            <div className="servicesBox">
              <div className="servicesIcon">
                <img src={chatIcon} alt="ChatIcon" />
              </div>
              <div className="servicesText">
                <p>Free Consultation</p>
              </div>
            </div>
            {/* Hotel Bookings */}
            <div className="servicesBox">
              <div className="servicesIcon">
                <img src={HotelIcon} alt="HotelIcon" />
              </div>
              <div className="servicesText">
                <p>Hotel Bookings</p>
              </div>
            </div>
            {/* Flight Bookings */}
            <div className="servicesBox">
              <div className="servicesIcon">
                <img src={FlightIcon} alt="FlightIcon" />
              </div>
              <div className="servicesText">
                <p>Flight Bookings</p>
              </div>
            </div>
            {/* Medical Visa Assistance */}
            <div className="servicesBox">
              <div className="servicesIcon">
                <img src={MedicalVisaIcon} alt="MedicalVisaIcon" />
              </div>
              <div className="servicesText">
                <p>Medical Visa Assistance</p>
              </div>
            </div>
          </Col>

          {/* second half */}

          <Col xs={12} md={6} xl={3}>
            {/* Documentation Assistance Post Arrival */}
            <div className="servicesBox">
              <div className="servicesIcon">
                <img src={DocumentIcon} alt="DocumentIcon" />
              </div>
              <div className="servicesText">
                <p>Documentation Assistance Post Arrival</p>
              </div>
            </div>
            {/* Online Appointments with Doctors */}
            <div className="servicesBox">
              <div className="servicesIcon">
                <img src={DoctorIcon} alt="DoctorIcon" />
              </div>
              <div className="servicesText">
                <p>Online Appointments with Doctors</p>
              </div>
            </div>
            {/* Online Follow Ups Pre & Post Treatment */}
            <div className="servicesBox">
              <div className="servicesIcon">
                <img src={CareIcon} alt="CareIcon" />
              </div>
              <div className="servicesText">
                <p>Online Follow Ups Pre & Post Treatment</p>
              </div>
            </div>
            {/* Hospital Selection & Treatment Scheduling */}
            <div className="servicesBox">
              <div className="servicesIcon">
                <img src={HospitalIcon} alt="HospitalIcon" />
              </div>
              <div className="servicesText">
                <p>Hospital Selection & Treatment Scheduling</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
